import { useEffect } from "react"
import { loadModules } from "esri-loader"
import usePromise from "react-use-promise"

/** Load esri modules via a hook */
export const useEsriModules = <T extends unknown[]>(
  esriModules: string[]
): T | undefined[] => {
  /** Load the modules into state */
  const [modules, error] = usePromise<T>(
    loadModules<T>(esriModules),
    esriModules
  )

  /** Warn if there's an error */
  const moduleNames = esriModules.join(", ")
  useEffect(() => {
    if (error) {
      console.warn(
        "Error loading modules: " +
          moduleNames +
          ". You may have spelt the module accessor wrong.",
        error
      )
    }
  }, [error, moduleNames])

  return modules || []
}
